import { fetch } from '@/utils/request';

// 基础
const cityTree = (callback) => fetch('/admin/common/getCityTree','GET',{}, callback);
const authLogin = (param, callback) => fetch('/admin/auth/login','POST',param, callback);
const authLogout = (callback) => fetch('/admin/auth/logout','POST',false, callback);
const myIndex = (callback) => fetch('/admin/my/index','GET',{}, callback);
const myUpdate = (param, callback) => fetch('/admin/my/update','POST',param, callback);
const myPrivs = (callback) => fetch('/admin/my/privs','GET',{}, callback);
const myUpdatePwd = (param, callback) => fetch('/admin/my/resetpwd','POST',param, callback);
const sysSet = (callback) => fetch('/admin/sys/set','GET',{}, callback);
const codeImg = (callback) => fetch('/admin/captcha','GET',{}, callback);

// 文件
const FileUpload = (param, callback) => fetch('/admin/common/uploadimg','POST',param, callback);
const fileList = (param, callback) => fetch('/admin/common/filelist','GET',param, callback);
const filedel = (param, callback) => fetch('/admin/common/filedel','POST',param, callback);
const filesign = (param, callback) => fetch('/admin/common/filesign','POST',param, callback);

const sysFileIndex = (param, callback) => fetch('/admin/sys/file/index','GET',param, callback);
const sysFileDel = (param, callback) => fetch('/admin/sys/file/del','POST',param, callback);

// 系统
const sysDetail = (callback) => fetch('/admin/sys/info','GET', {}, callback);
const sysEdit = (param, callback) => fetch('/admin/sys/update','POST', param, callback);
const sysCommissionCheck = (param, callback) => fetch('/admin/sys/commission/check','GET', param, callback);

// 用户
const userIndex = (param, callback) => fetch('/admin/user/index','GET', param, callback);
const userDetail = (param, callback) => fetch('/admin/user/detail','GET', param, callback);
const userAdd = (param, callback) => fetch('/admin/user/add','POST', param, callback);
const userEdit = (param, callback) => fetch('/admin/user/edit','POST', param, callback);
const userDelete = (param, callback) => fetch('/admin/user/del','POST', param, callback);
const userShenhe = (param, callback) => fetch('/admin/user/shenhe','POST', param, callback);
const userVisitLog = (param, callback) => fetch('/admin/user/visitlog','GET', param, callback);

// 群组
const groupIndex = (param, callback) => fetch('/admin/group/index','GET', param, callback);
const groupDetail = (param, callback) => fetch('/admin/group/detail','GET', param, callback);
const groupAdd = (param, callback) => fetch('/admin/group/add','POST', param, callback);
const groupEdit = (param, callback) => fetch('/admin/group/edit','POST', param, callback);
const groupDelete = (param, callback) => fetch('/admin/group/del','POST', param, callback);

// 菜单
const menuIndex = (param, callback) => fetch('/admin/menu/index','GET', param, callback);
const menuDetail = (param, callback) => fetch('/admin/menu/detail','GET', param, callback);
const menuAdd = (param, callback) => fetch('/admin/menu/add','POST', param, callback);
const menuEdit = (param, callback) => fetch('/admin/menu/edit','POST', param, callback);
const menuDelete = (param, callback) => fetch('/admin/menu/del','POST', param, callback);

// 单页
const pageIndex = (param, callback) => fetch('/admin/page/index','GET', param, callback);
const pageDetail = (param, callback) => fetch('/admin/page/detail','GET', param, callback);
const pageEdit = (param, callback) => fetch('/admin/page/edit','POST', param, callback);

// 素材管理
const bannerIndex = (param, callback) => fetch('/admin/banner/index','GET', param, callback);
const bannerDetail = (param, callback) => fetch('/admin/banner/detail','GET', param, callback);
const bannerAdd = (param, callback) => fetch('/admin/banner/add','POST', param, callback);
const bannerEdit = (param, callback) => fetch('/admin/banner/edit','POST', param, callback);
const bannerDelete = (param, callback) => fetch('/admin/banner/del','POST', param, callback);

// 反馈
const feedbackIndex = (param, callback) => fetch('/admin/feedback/index','GET', param, callback);

// 门店审核
const storeIndex = (param, callback) => fetch('/admin/store/index','GET', param, callback);
const storeInfo = (param, callback) => fetch('/admin/store/info','GET', param, callback);
const storeUpdateLocation = (param, callback) => fetch('/admin/store/updateLocation','POST', param, callback);
const storeShenhe = (param, callback) => fetch('/admin/store/shenhe','POST', param, callback);

export default {
  cityTree,
  authLogin,
  authLogout,
  myIndex,
  myUpdate,
  myPrivs,
  myUpdatePwd,
  sysSet,
  codeImg,
  FileUpload,
  fileList,
  filedel,
  filesign,
  sysDetail,
  sysEdit,
  sysCommissionCheck,
  userIndex,
  userDetail,
  userAdd,
  userEdit,
  userDelete,
  userShenhe,
  userVisitLog,
  groupIndex,
  groupDetail,
  groupAdd,
  groupEdit,
  groupDelete,
  menuIndex,
  menuDetail,
  menuAdd,
  menuEdit,
  menuDelete,
  pageIndex,
  pageDetail,
  pageEdit,
  bannerIndex,
  bannerDetail,
  bannerAdd,
  bannerEdit,
  bannerDelete,
  feedbackIndex,
  sysFileIndex,
  sysFileDel,
  storeIndex,
  storeInfo,
  storeUpdateLocation,
  storeShenhe
}
